/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IOrganizationUsersTileViewProps } from './organization-users-tile';

const OrganizationUsersTileView: React.FC<IOrganizationUsersTileViewProps> = props => {
    const { OrganizationUsersTile, heading, description, links } = props;

    return (
        <Module {...OrganizationUsersTile}>
            {heading}
            {description}
            {links}
        </Module>
    );
};

export default OrganizationUsersTileView;
